import { $ as e, C as t, F as n, L as r, S as i, _ as a, at as o, h as s, i as c, m as l, nt as u, ot as d, p as f, q as ee, rt as p, t as m, v as h, w as g, z as _ } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as v, t as y } from "./i18n-lite-BcmwMblk.js";
//#region src/webcomponents/test-top-mdp/locales/de-AT.json
var b = {}, x = {}, S = {}, C = {}, w = {}, T = { "test-top-mdp": {
	passwords: { title: "Top {{count}} des mots de passe en France" },
	loginForm: {
		title: "Connexion",
		login: "Identifiant",
		loginValue: "Ulysse",
		password: "Mot de passe",
		passwordPlaceholder: "Séléctionnez un mot de passe...",
		submit: "Tester",
		attemptsCount: "Nombre d’essais : {{count}}"
	},
	feedback: { positive: {
		title_one: "{{feedback}} en un essai.",
		title_other: "{{feedback}} en {{count}} essais."
	} }
} }, E = {}, D = {}, O = "data:image/svg+xml,%3csvg%20width='18'%20height='18'%20viewBox='0%200%2018%2018'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9%2011.25V12.75M4.5%2015.75H13.5C13.8978%2015.75%2014.2794%2015.592%2014.5607%2015.3107C14.842%2015.0294%2015%2014.6478%2015%2014.25V9.75C15%209.35218%2014.842%208.97064%2014.5607%208.68934C14.2794%208.40804%2013.8978%208.25%2013.5%208.25H4.5C4.10218%208.25%203.72064%208.40804%203.43934%208.68934C3.15804%208.97064%203%209.35218%203%209.75V14.25C3%2014.6478%203.15804%2015.0294%203.43934%2015.3107C3.72064%2015.592%204.10218%2015.75%204.5%2015.75ZM12%208.25V5.25C12%204.45435%2011.6839%203.69129%2011.1213%203.12868C10.5587%202.56607%209.79565%202.25%209%202.25C8.20435%202.25%207.44129%202.56607%206.87868%203.12868C6.31607%203.69129%206%204.45435%206%205.25V8.25H12Z'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", k = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.5%207L9.5%2017L4.5%2012'%20stroke='%23007740'%20stroke-width='1.6'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", A = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.875%207.125L7.125%2016.875M7.125%207.125L16.875%2016.875'%20stroke='%23A94B0C'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", j = { class: "container" }, M = { class: "card" }, N = ["arial-level"], P = [
	"aria-disabled",
	"aria-selected",
	"onClick"
], F = { class: "password" }, I = { class: "card" }, L = ["arial-level"], R = { class: "lock-icon" }, z = ["src"], B = { class: "form" }, V = { class: "form__field" }, H = { for: "login" }, U = ["value"], W = { class: "form__field" }, G = { for: "password" }, K = ["value", "placeholder"], q = ["src"], J = ["aria-disabled"], Y = { class: "attempts-count" }, X = { class: "attempts-count__count" }, Z = {
	key: 0,
	class: "feedback",
	"aria-live": "polite"
}, Q = ["arial-level", "innerHTML"], te = ["innerHTML"], $ = /*#__PURE__*/ m(/* @__PURE__ */ g({
	__name: "TestTopMdp.ce",
	props: {
		titleLevel: { type: Number },
		passwords: { type: Array },
		expectedPassword: { type: String },
		feedback: { type: Object }
	},
	setup(c, { expose: m }) {
		let g = c, { t: y } = v(), b = l(() => g.titleLevel ?? 2), x = e(), S = e([]), C = l(() => S.value.at(-1)), w = l(() => g.passwords.map((e) => ({
			password: e,
			selected: e === x.value,
			attempted: S.value.includes(e),
			expected: e === g.expectedPassword
		}))), T = l(() => S.value.length), E = l(() => C.value === g.expectedPassword), D = l(() => {
			if (C.value !== void 0 && x.value === void 0) return E.value ? {
				title: y("test-top-mdp.feedback.positive.title", {
					feedback: g.feedback.success.title,
					count: T.value
				}),
				content: g.feedback.success.content
			} : g.feedback.failed;
		});
		function $(e) {
			E.value || e.attempted || (x.value = e.password);
		}
		function ne() {
			x.value &&= (S.value.push(x.value), void 0);
		}
		function re() {
			x.value = void 0, S.value = [];
		}
		return m({ reset: re }), (e, c) => {
			let l = _("i18n");
			return n(), h(f, null, [s("div", j, [s("div", M, [s("div", {
				class: "title",
				role: "heading",
				"arial-level": b.value
			}, d(e.$t("test-top-mdp.passwords.title", { count: w.value.length })), 9, N), s("div", {
				class: "passwords",
				style: o({ "--count-per-column": Math.round(w.value.length / 2) })
			}, [(n(!0), h(f, null, r(w.value, (e, t) => (n(), h("button", {
				key: e.password,
				class: p({
					selected: e.selected || e.attempted && e.expected,
					disabled: e.attempted && !e.expected
				}),
				"aria-disabled": E.value || e.attempted,
				"aria-selected": e.selected,
				onClick: (t) => $(e)
			}, [i(" #" + d(t + 1) + " ", 1), s("span", F, d(e.password), 1)], 10, P))), 128))], 4)]), s("div", I, [s("div", {
				class: "title",
				role: "heading",
				"arial-level": b.value
			}, [s("div", R, [s("img", {
				src: u(O),
				alt: ""
			}, null, 8, z)]), i(" " + d(e.$t("test-top-mdp.loginForm.title")), 1)], 8, L), s("div", B, [
				s("div", V, [s("label", H, d(e.$t("test-top-mdp.loginForm.login")), 1), s("input", {
					id: "login",
					type: "text",
					value: e.$t("test-top-mdp.loginForm.loginValue"),
					readonly: "",
					tabIndex: "-1"
				}, null, 8, U)]),
				s("div", W, [
					s("label", G, d(e.$t("test-top-mdp.loginForm.password")), 1),
					s("input", {
						id: "password",
						type: "text",
						value: x.value ?? C.value,
						readonly: "",
						placeholder: e.$t("test-top-mdp.loginForm.passwordPlaceholder"),
						tabIndex: "-1",
						class: p({
							right: D.value !== void 0 && E.value,
							wrong: D.value !== void 0 && !E.value
						})
					}, null, 10, K),
					D.value === void 0 ? a("", !0) : (n(), h("img", {
						key: 0,
						src: E.value ? u(k) : u(A),
						alt: "",
						class: "form__field-icon"
					}, null, 8, q))
				]),
				s("button", {
					"aria-disabled": !x.value,
					onClick: c[0] ||= (e) => ne()
				}, d(e.$t("test-top-mdp.loginForm.submit")), 9, J),
				s("p", Y, [t(l, { t: "test-top-mdp.loginForm.attemptsCount" }, {
					count: ee(() => [s("span", X, d(T.value), 1)]),
					_: 1
				})])
			])])]), D.value === void 0 ? a("", !0) : (n(), h("div", Z, [s("div", {
				class: "feedback__title",
				role: "heading",
				"arial-level": b.value + 1,
				innerHTML: D.value.title
			}, null, 8, Q), s("div", {
				class: "feedback__content",
				innerHTML: D.value.content
			}, null, 8, te)]))], 64);
		};
	}
}), [["styles", ["*{color:#5e6c84;box-sizing:border-box;font-family:Roboto,sans-serif;font-size:14px}p{margin:0}.container{flex-direction:row;gap:16px;display:flex}.card{background:#fff;border-radius:16px;width:50%;padding:24px;box-shadow:0 2px 5px #4a3aff40,inset 0 -2px 5px #4a3aff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}.title{color:#122647;align-items:center;gap:8px;font-family:Nunito,Roboto,sans-serif;font-size:20px;font-weight:700;display:flex}.passwords{grid-template-rows:repeat(var(--count-per-column,5), 1fr);grid-auto-flow:column;gap:8px;margin-top:16px;display:grid}.passwords>button{cursor:pointer;color:#122647;background-color:#eaf1ff;border-style:none;border-radius:8px;align-items:center;gap:4px;height:44px;padding:8px 16px;display:flex}.passwords>button.selected{color:#fff;background-color:#3b82f6}.passwords>button.disabled{color:#5e6c84;background-color:#f4f5f7}.passwords>button[aria-disabled=true]{cursor:not-allowed}.lock-icon{aspect-ratio:1;background-color:#2c75ff;border-radius:50%;justify-content:center;align-items:center;width:34px;display:flex}.password{color:inherit;font-weight:700;line-height:20px}.form{flex-direction:column;gap:16px;margin-top:24px;display:flex}.form__field{flex-direction:column;gap:8px;display:flex;position:relative}.form__field-icon{aspect-ratio:1;width:24px;position:absolute;bottom:12px;left:12px}.form input{pointer-events:none;color:#122647;background-color:#f4f5f7;border:1px solid #cdd1d9;border-radius:10px;align-items:center;height:50px;padding:12px 16px;font-size:16px;display:flex}.form input.right{color:#007740;background-color:#e6f6ef;border-color:#00a85a;padding-left:40px}.form input.wrong{color:#99241c;background-color:#fbebea;border-color:#d73328;padding-left:40px}.form label{pointer-events:none}.form button{color:#fff;cursor:pointer;background-color:#122647;border-style:none;border-radius:10px;justify-content:center;align-items:center;height:50px;padding:12px 16px;font-size:16px;font-weight:700;display:flex}.form button[aria-disabled=true]{color:#5e6c84;cursor:not-allowed;background-color:#cdd1d9}.attempts-count{text-align:center}.attempts-count__count{color:#122647;font-weight:700}.feedback{flex-direction:column;margin-top:24px;display:flex}.feedback__title{color:#fff;background-color:#1f53b5;border-radius:8px 8px 0 0;align-self:start;padding:4px 8px;font-size:12px;font-weight:700}.feedback__title *{color:inherit}.feedback__content{color:#122647;background-color:#eaf1ff;border-radius:0 8px 8px;padding:8px}.feedback__content *{color:inherit}@media only screen and (width<=680px){.container{flex-direction:column}.card{width:100%}}"]]]);
y.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": b,
	"./locales/en.json": x,
	"./locales/es-419.json": S,
	"./locales/es.json": C,
	"./locales/fr-BE.json": w,
	"./locales/fr.json": T,
	"./locales/it.json": E,
	"./locales/nl.json": D
})), window.customElements.define("test-top-mdp", c($, { configureApp(e) {
	y.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(y);
} }));
//#endregion
